/**
 * @module wdh-hearing-test
 */
import WDHHearingTest from './src/js/wdh-hearing-test';
export default WDHHearingTest;